<!-- 社会责任 -->
<template>
  <div class="box">
    <!-- 头部 -->
    <headers></headers>
    <el-carousel :interval="3000">
      <el-carousel-item>
        <img src="@/assets/homePage/合作与发展banner.png" class="images">
      </el-carousel-item>
    </el-carousel>
    <!-- 中间内容区域 -->
    <div class="content">
      <h2 class="H2">企业社会责任</h2>
      <img style="width: 100%;margin-top: 3rem;" src="@/assets/cooperation/social_responsibility/企业社会责任.png" alt="" />
      <div class="content_1">
     
          <img src="@/assets/cooperation/social_responsibility/社会责任.png" alt="">
       
        <div class="text">
          <div v-for="item in textList" :key="item.id">
            <li>{{ item.name }}</li>
            <p style="text-indent: 2em;">{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <foot></foot>
  </div>
  <div class="_div">
    <!-- 头部 -->
    <move_header></move_header>
    <!-- 轮播图 -->
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <img src="@/assets/homePage/合作与发展banner.png" class="images">
      </van-swipe-item>
    </van-swipe>
    <!-- 内容区域 -->
    <div class="content">
      <h2>企业社会责任</h2>
      <img  src="@/assets/cooperation/social_responsibility/企业社会责任.png" alt="" />
      <h2>盛泰-社会责任</h2>
      <div v-for="item in textList" :key="item.id">
        <li>{{item.name}}</li>
        <p>{{item.title}}</p>
      </div>
    </div>
    <!-- 底部 -->
    <move_foot></move_foot>
  </div>
</template>

<script>
import foot from "../components/foot.vue";
import headers from "../components/header.vue";
import move_foot from "../move_components/move_foot.vue";
import move_header from "../move_components/move_header.vue";
import { useRoute } from "vue-router";
import { reactive, toRefs } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";

export default {
  components: { foot, headers, move_header, move_foot },

  setup() {
    const route = useRoute();
    const state = reactive({
      textList: [
        { id: 1, name: '提升研发技术自主创新', title: '盛泰光电自成立起，深知企业应对社会贡献一己之力的使命，在营收持续成长的同时，盛泰也不遗余力地履行企业的社会责任。对环境保护的承诺，明礼诚信，确保产品货真价实，公司还时刻关注影像系统的新技术发展动态，深刻把握技术发展趋势，加大研发投入、加强自主创新、加快技术突破。' },
        { id: 2, name: '改善环境绩效', title: '公司一直把保护环境和维护自然和谐作为生产的重要环节，遵守环境保护有关法律、法规及国际公约。防止污染、降低资源能源的耗用，持续改善环境绩效。培养员工环境意识，鼓励全员支持并参加环境保护活动。销售符合客户及其终端市场的环保要求的产品。' }
      ]
    });
    onMounted(() => {
    });
    return {
      ...toRefs(state),
    };
  },
};
</script>

<style scoped lang="less">
.el-carousel {
  max-width: 1920px;
  margin: 0 auto;
}

.box {

  width: 100%;

  .content {
    max-width: 1920px;
    margin: 0 auto;
    width: 70%;

    li {
      list-style-type: square;
      font-size: 1.7rem;
      font-weight: bold;
    }
  
    .content_1 {
      position: relative;
      box-sizing: border-box;
      margin: 50px 0;
      img{
        width: 100%;
      }
      .text{
        position: absolute;
        left:300px;top:300px;
        width: 65%;
        div{
          p{
            font-size: 1.2rem;
          }
        }
      }
      .text {
        flex: 3;
        padding: 50px;

        p {
          font-size: 1.2rem;
        }
      }
    }

    .H2 {
      margin-top: 50px;
      font-size: 1.7rem;
    }

    .H2::before {
      content: "";
      width: 30%;
      height: 2px;
      background-color: #c7000b;
      position: absolute;
      margin-top: 40px;
      left: 19%;
      transform: translateX(-50%);
      // top:55px;
      min-width: 35px;
      max-width: 35px;
    }
  }
}

.images {
  width: 100%;
  height: auto;
  max-height: 600px;
}

::v-deep .el-carousel {
  max-width: 1920px;
  margin: 0 auto;
  overflow-y: hidden;
  height: auto;
  max-height: 600px;
  // max-height: 700px;
}

::v-deep .el-carousel__container {
  height: 100% !important;
  min-height: 500px;
}

.el-carousel {
  max-width: 1920px;
  margin: 0 auto;
}

::v-deep .el-card {
  border-radius: 8px;
}

// 小屏幕区域
@media only screen and (min-width: 767px) {
  .box {
    display: block;
  }

  ._div {
    display: none;
  }
}

@media only screen and (max-width: 767px) {
  .box {
    display: none;
  }

  ._div {
    display: block;

    .content {
      padding: 30px;
      img{width: 100%;}
       li {
      list-style-type: square;
      font-size: 70px;
      font-weight: bold;
    }
    p{
      font-size: 50px;
    }
      h2 {
        text-align: center;
        font-size: 80px;
      }

      h2::before {
        content: "";
        width: 30%;
        height: 8px;
        background-color: #c7000b;
        position: absolute;
        margin-top: 100px;
        left: 50%;
        transform: translateX(-50%);
        min-width: 100px;
        max-width: 100px;
      }

    }
  }
}
</style>